/**
 * Кодирует строку query-параметров.
 *
 * Пустые параметры (которые кастятся к false) игнорируются!.
 *
 * @param params параметры
 */
export const buildQueryString = (params: Record<string, string | number | boolean | undefined>) => {
  const encodedParams: string[] = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const param in params) {
    if (!Object.prototype.hasOwnProperty.call(params, param)) {
      continue;
    }
    const value = params[param];
    if (value === undefined || value === null) {
      continue;
    }
    encodedParams.push(`${encodeURIComponent(param)}=${encodeURIComponent(String(value))}`);
  }

  return encodedParams.join('&');
};

/**
 * Собирает адрес по url и объекту параметров.
 *
 * @param url адрес без query-параметров
 * @param params параметры
 */
export const buildUrl = (url: string, params: Record<string, string | number | boolean | undefined>) => {
  const paramsString = buildQueryString(params);

  return url + (paramsString ? '?' : '') + paramsString;
};
